export const lunchroom = {
  hero: {
    title: 'Two-B "the tastiest sandwiches in the region" grows online through Bistroo',
    description: 'Two B by Mondie is a well-known spot in Veldhoven and surrounding areas, and recently opened a new location in Helmond & Best. They serve the entire region with delicious sandwiches.'
  },
  testimonials: {
    1: {
      text: '"Bistroo saves us a lot of time every day and significantly reduces customer frustration."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner'
    },
    2: {
      text: '"The menu is easy to update and gives customers a clear overview."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner'
    }
  },
  challenge: {
    paragraph: {
      title: 'Innovation takes time',
      text: 'Previously, phone orders and in-person pickups were the main ways to serve customers, which resulted in long queues and inefficiencies during busy periods. The owner, Lars, has been working with Bistroo for over 2 years and is happy to share some of the challenges they faced before the collaboration, as well as the solutions Bistroo provided.',
    },
    paragraph_2: {
      title: 'The challenge',
      bullets: {
        1: 'Two B by Mondie often experienced a rush during lunch hours, resulting in long lines and less satisfied customers.',
        2: 'Orders placed over the phone caused delays and confusion, especially during busy periods.',
        3: 'Human error and miscommunication during phone orders sometimes led to incorrect orders, resulting in dissatisfied customers and wasted time.',
        4: 'Customers increasingly wanted the convenience of online ordering and expected a seamless pickup experience without long waits.',
      }
    }
  },
  solution: {
    title: 'The solution',
    checklist: {
      1: 'Thanks to Bistroo, customers could place their orders in advance, allowing Two B by Mondie to work more efficiently during peak moments and enabling customers to pick up their orders without waiting.',
      2: 'With Bistroo’s online ordering solution, Two B by Mondie had a clear overview of orders, which reduced errors and allowed the kitchen to operate more efficiently.',
      3: 'With Bistroo, Two B by Mondie could manage their own busy periods better, improving the customer experience and maximizing revenue.',
      4: 'All orders placed through Bistroo were prepaid, reducing the risk of uncollected orders and streamlining the pickup process at the counter.'
    }
  },
  conclusion: {
    title: 'The conclusion',
    text: {
      1: 'Bistroo’s online ordering solution not only provided Two B by Mondie with an effective way to overcome these challenges but also transformed their operations. “Since we started working with Bistroo, our customers can easily place their orders online. This saves us a lot of time every day and significantly reduces customer frustration,” says Lars. He also appreciates the user-friendliness of the menu editing system and the excellent customer service offered by Bistroo:“Whenever we have questions, we get quick and professional support.”',
      2: 'Additionally, Bistroo always offers a 30-day free trial, allowing businesses to try the service without obligation. In nearly all cases, ther iss a mutual intention to continue using Bistroo’s online ordering solution, which reflects the platforms value and effectiveness for lunchrooms like Two B by Mondie.'
    }
  }
}
